<template>
  <section>
    <b-button v-b-modal.credit-memo-modal size="sm" variant="primary" class="mr-2" v-show="!componentBtn"><i class="fa fa-plus" aria-hidden="true"></i> Add</b-button>
    <b-modal
      id="credit-memo-modal"
      size="sm"
      @ok="onSubmit"
      @shown="initializeModal()"
      @hidden="onReset"
      :title="modalTitle"
      :ok-title=" isSaving ? 'Submitting...' : 'Submit'"
      :ok-disabled="isSaving"
      header-close-label="Cancel"
      isResizable
      centered
    >
      <div class="modal-body">
        <b-row>
          <b-col v-if="!isSOPayment">
            <b-form-group label="Company" class="required">
              <span v-if="propCompanyId">{{propCompanyName}}</span>
              <vue-simple-suggest
                v-if="!propCompanyId"
                class="suggest-input form-control"
                :class="{ 'is-invalid': $v.formData.companyId.$error }"
                :styles="autoCompleteStyle"
                :list="getListOfNames"
                :max-suggestions="20"
                :min-length="2"
                :debounce="200"
                :filter-by-query="true"
                value-attribute="id"
                display-attribute="name"
                @input="suggestNameChange"
                @select="onSuggestNameSelect"
                @blur="$v.formData.companyId.$touch()"
                @request-done="isLoading=!isLoading"
              >
                <div slot="misc-item-below" v-if="isLoading" class="misc-item">
                  <span>Loading companies...</span>
                </div>
              </vue-simple-suggest>
              <b-form-invalid-feedback>Please select company</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Date" class="required">
              <date-picker v-model="formData.paymentDate" :class="{ 'is-invalid': $v.formData.paymentDate.$error }" :config="datePickerOptions" @blur="$v.formData.paymentDate.$touch()"></date-picker>
              <div class="invalid-feedback">
                <div v-if="!$v.formData.paymentDate.required">Payment Date is required</div>
              </div>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Payment Method">
              <b-form-select v-model="formData.paymentMethodId" :class="{ 'is-invalid': $v.formData.paymentMethodId.$error }" @blur="$v.formData.paymentMethodId.$touch()">
                <option v-for="method in sortSelect(paymentMethods)" :key="method.id" :value="method.id">
                  {{method.name}}
                </option>
              </b-form-select>
              <div class="invalid-feedback">
                <div v-if="!$v.formData.paymentMethodId.required">Payment Method is required</div>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <!--<b-form-group label="Amount" class="required mr-2">
              <b-form-input
                type="number"
                :class="{ 'is-invalid': $v.formData.amount.$error }"
                @blur="$v.formData.amount.$touch()"
                v-model.trim="formData.amount"
              ></b-form-input>
              <b-form-invalid-feedback>Amount should be > 0</b-form-invalid-feedback>
            </b-form-group>-->
            <b-form-group label="Amount" >
              <b-input-group prepend="$" size="sm">
                <b-form-input v-model.number="formData.amount" :class="{ 'is-invalid': $v.formData.amount.$error }" @blur="$v.formData.amount.$touch()" type="number" min="0"></b-form-input>
              </b-input-group>
              <div class="invalid-feedback">
                <div v-if="!$v.formData.amount.required">Amount is required</div>
              </div>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Reference Number">
              <b-form-input v-model="formData.referenceNumber"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Comment" class="mr-2">
              <b-form-input
                type="text"
                v-model.trim="formData.comment"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </section>
</template>

<script>
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
  import { required, decimal } from 'vuelidate/lib/validators';
  import { numberGreaterThan } from '@/shared/validators';
  import VueSimpleSuggest from 'vue-simple-suggest';
  import { AUTO_COMPLETE_STYLES,DATE_FORMAT } from '@/shared/constants';

  export default {
    components: {
      VueSimpleSuggest,
    },
    props: {
      propCompanyId: {
        type: [String, Number],
        default: 0,
      },
      propCompanyName: {
        type: [String],
        default: '',
      },
      propAmount: {
        type: [String, Number],
        default: ''
      },
      componentBtn: {
        type: Boolean,
        default: false
      },
      isPending: {
        type: Boolean,
        default: false,
      },
      isRefund: {
        type: Boolean,
        default: false,
      },
      rmaId: {
        type: [String, Number],
        default: null
      },
      isSOPayment:{
        type: Boolean,
        default: false,
      },
      salesOrderId: {
        type: [String, Number],
        default: 0,
      }
    },
    data() {
      return {
        formData: {
          id: 0,
          companyId: this.propCompanyId || '',
          amount: '',
          balance: '',
          comment: '',
          active: true,
          paymentDate: null,
          salesOrderId: this.salesOrderId || 0,
          paymentMethodId: 0,
          referenceNumber: null,
        },
        autoCompleteStyle: AUTO_COMPLETE_STYLES,
        isLoading: false,
        selectedCompanyName:'',
        isSaving:false,
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
      };
    },
    validations: {
      formData: {
        paymentDate: { required },
        paymentMethodId: {required},
        amount: { required, decimal, numberGreaterThan: numberGreaterThan(0) },
        companyId: { required },
      },
    },
    computed: {
      ...mapState('creditMemos', ['creditMemo']),
      ...mapGetters('lookup', ['paymentMethods']),
      modalTitle(){
        let title = ``;
        if(this.isSOPayment){
          title = `Payments`;
        }else{
          title = `Add Credit Memo`;
        }
        return title;
      }
    },
    methods: {
      ...mapMutations('creditMemos', ['setItem']),
      ...mapActions('creditMemos', ['manageCreditMemo']),
      ...mapActions('companies', ['getByNameAndAccountType']),
      async getListOfNames(name) {
        return await this.getByNameAndAccountType({typeId: 0, name});
      },
      async onSuggestNameSelect(suggestion) {
        this.formData.companyId = suggestion.id;
        this.selectedCompanyName=suggestion.name;
      },
      async suggestNameChange(val) {
        this.isLoading = true;
        if(this.selectedCompanyName!=val){this.formData.companyId=''};
      },
      async onSubmit(e) {
        this.$v.formData.$touch();
        if (this.$v.formData.$invalid) {
          e.preventDefault();
          return;
        }
        try {
          this.isSaving=true;
          this.formData.balance = this.formData.amount;
          if(this.salesOrderId) {
            this.formData.salesOrderId = this.salesOrderId;
          }

          const id = await this.manageCreditMemo(this.formData);
          this.isSaving=false;
          if (id) {
            this.$emit('created');
            this.$emit('receivedMemo');
            this.onReset(true);
          } else {
            e.preventDefault();
          }
        } catch {
          this.isSaving=false;
          e.preventDefault();
        }
      },
      onReset(updateList = false) {
        this.$emit('onChange', updateList);
        /*this.setCreditMemo({});*/
        this.setItem({ resource: 'CreditMemo', payload: {} });
      },
      async initializeModal(getData = false) {
        this.formData = {
          id: 0,
          companyId: this.propCompanyId || '',
          paymentDate: null,
          amount: this.propAmount || '',
          balance: '',
          comment: '',
          isPending: this.isPending,
          isRefund: this.isRefund,
          rmaId: this.rmaId,
          active: true,
          salesOrderId: this.salesOrderId || 0,
          paymentMethodId: 0,
          referenceNumber: null,
        },
        this.$v.$reset();
        this.$v.formData.$reset();
        /*if (Object.entries(this.creditMemo).length !== 0) {
          this.formData = { ...this.creditMemo };
        }
        if (getData) {
          this.chartOfAccounts = await this.getChartOfAccounts(7);
        }*/
      },
      openModal() {
        this.$bvModal.show('credit-memo-modal');
      }
    },
    mounted() {

    },
  };
</script>
